export default async function addNewUser(inObj){
    const baseLink = process.env.REACT_APP_END_POINT_BASE;
    let finalRes = await fetch(baseLink + 'newsletter', {  // Replace with your API endpoint
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inObj),
      })
    .then(async response => {
        if (!response.ok) {
            //throw new Error(await response.json());
            const errorData = await response.json();
            throw new Error(errorData.message || 'Something went wrong');
        }

        const successData = await response.json();
        return await successData;
    })
    .then(data => {
        //add message of new email
        return { isOk: true, message: "" };
    })
    .catch(error => {
        return { isOk: false, message: error.message } ;
        // Handle the error, e.g., display an error message
    });
    return finalRes;
}
                